"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const supportedFiat = [
    { ticker_symbol: "JPY", min_amount: "6970", max_amount: "2787700" },
    { ticker_symbol: "CAD", min_amount: "67.00", max_amount: "26461.00" },
    { ticker_symbol: "GBP", min_amount: "40.00", max_amount: "15624.00" },
    { ticker_symbol: "AUD", min_amount: "76.00", max_amount: "30083.00" },
    { ticker_symbol: "CHF", min_amount: "44.00", max_amount: "17394.00" },
    { ticker_symbol: "CZK", min_amount: "1094.00", max_amount: "437379.00" },
    { ticker_symbol: "NZD", min_amount: "82.00", max_amount: "32503.00" },
    { ticker_symbol: "HUF", min_amount: "17375.00", max_amount: "6949640.00" },
    { ticker_symbol: "ILS", min_amount: "186.00", max_amount: "74384.00" },
    { ticker_symbol: "USD", min_amount: "50.00", max_amount: "20000.00" },
    { ticker_symbol: "EUR", min_amount: "46.00", max_amount: "18207.00" },
    { ticker_symbol: "INR", min_amount: "4113.00", max_amount: "1644959.00" },
    { ticker_symbol: "AED", min_amount: "184.00", max_amount: "73462.00" },
    { ticker_symbol: "UAH", min_amount: "1873.00", max_amount: "749194.00" },
    { ticker_symbol: "VND", min_amount: "1184575", max_amount: "473830000" },
    { ticker_symbol: "KZT", min_amount: "22548.00", max_amount: "9019143.00" },
    { ticker_symbol: "DOP", min_amount: "2810.00", max_amount: "1123977.00" },
    { ticker_symbol: "PEN", min_amount: "183.00", max_amount: "73067.00" },
    { ticker_symbol: "MDL", min_amount: "903.00", max_amount: "360995.00" },
    { ticker_symbol: "QAR", min_amount: "183.00", max_amount: "72819.00" },
    { ticker_symbol: "GEL", min_amount: "130.00", max_amount: "51900.00" },
    { ticker_symbol: "UYU", min_amount: "1910.00", max_amount: "763920.00" },
    { ticker_symbol: "CLP", min_amount: "41514", max_amount: "16605392" },
    { ticker_symbol: "CRC", min_amount: "27400.00", max_amount: "10959727.00" },
    { ticker_symbol: "NAD", min_amount: "883.00", max_amount: "352990.00" },
    { ticker_symbol: "AZN", min_amount: "85.00", max_amount: "33763.00" },
    { ticker_symbol: "HKD", min_amount: "390.00", max_amount: "155985.00" },
    { ticker_symbol: "MYR", min_amount: "228.00", max_amount: "90960.00" },
    { ticker_symbol: "NGN", min_amount: "38775.00", max_amount: "15509808.00" },
    { ticker_symbol: "SGD", min_amount: "67.00", max_amount: "26629.00" },
    { ticker_symbol: "TWD", min_amount: "1571.00", max_amount: "628330.00" },
    { ticker_symbol: "BGN", min_amount: "90.00", max_amount: "35610.00" },
    { ticker_symbol: "BRL", min_amount: "238.00", max_amount: "94882.00" },
    { ticker_symbol: "MAD", min_amount: "490.00", max_amount: "195756.00" },
    { ticker_symbol: "RON", min_amount: "225.00", max_amount: "89732.00" },
    { ticker_symbol: "MXN", min_amount: "842.00", max_amount: "336530.00" },
    { ticker_symbol: "NOK", min_amount: "509.00", max_amount: "203590.00" },
    { ticker_symbol: "DKK", min_amount: "340.00", max_amount: "135683.00" },
    { ticker_symbol: "SEK", min_amount: "527.00", max_amount: "210740.00" },
    { ticker_symbol: "ZAR", min_amount: "891.00", max_amount: "356211.00" },
    { ticker_symbol: "PLN", min_amount: "202.00", max_amount: "80484.00" },
    { ticker_symbol: "IDR", min_amount: "754263.00", max_amount: "301705000.00" },
    { ticker_symbol: "CNY", min_amount: "358.00", max_amount: "143099.00" },
    { ticker_symbol: "ALL", min_amount: "4795.00", max_amount: "1917997.00" },
    { ticker_symbol: "BDT", min_amount: "5504.00", max_amount: "2201417.00" },
    { ticker_symbol: "EGP", min_amount: "1546.00", max_amount: "618054.00" },
    { ticker_symbol: "PHP", min_amount: "2740.00", max_amount: "1095880.00" },
    { ticker_symbol: "THB", min_amount: "1726.00", max_amount: "690207.00" },
    { ticker_symbol: "JOD", min_amount: "36.00", max_amount: "14179.00" },
    { ticker_symbol: "KRW", min_amount: "63907", max_amount: "25562603" },
    { ticker_symbol: "KWD", min_amount: "16.00", max_amount: "6142.00" },
    { ticker_symbol: "COP", min_amount: "197800.00", max_amount: "79120000.00" },
    { ticker_symbol: "SAR", min_amount: "188.00", max_amount: "75019.00" },
    { ticker_symbol: "BOB", min_amount: "351.00", max_amount: "140270.00" },
    { ticker_symbol: "ANG", min_amount: "92.00", max_amount: "36560.00" },
    { ticker_symbol: "BBD", min_amount: "103.00", max_amount: "40959.00" },
    { ticker_symbol: "BMD", min_amount: "50.00", max_amount: "20000.00" },
    { ticker_symbol: "BND", min_amount: "68.00", max_amount: "26851.00" },
    { ticker_symbol: "BWP", min_amount: "659.00", max_amount: "263453.00" },
    { ticker_symbol: "DJF", min_amount: "9030", max_amount: "3611956" },
    { ticker_symbol: "GHS", min_amount: "571.00", max_amount: "228059.00" },
    { ticker_symbol: "GTQ", min_amount: "399.00", max_amount: "159250.00" },
    { ticker_symbol: "TZS", min_amount: "122750.00", max_amount: "49099998.00" },
    { ticker_symbol: "UGX", min_amount: "183192", max_amount: "73276686" },
    { ticker_symbol: "XOF", min_amount: "29870", max_amount: "11947997" },
    { ticker_symbol: "KGS", min_amount: "4380.00", max_amount: "1751964.00" },
    { ticker_symbol: "MZN", min_amount: "3163.00", max_amount: "1265008.00" },
    { ticker_symbol: "BAM", min_amount: "90.00", max_amount: "35624.00" },
    { ticker_symbol: "MNT", min_amount: "172298.00", max_amount: "68919121.00" },
    { ticker_symbol: "AMD", min_amount: "19745.00", max_amount: "7897852.00" },
    { ticker_symbol: "KHR", min_amount: "206351.00", max_amount: "82540002.00" },
    { ticker_symbol: "KYD", min_amount: "43.00", max_amount: "16904.00" },
    { ticker_symbol: "LBP", min_amount: "761234.00", max_amount: "304493542.00" },
    { ticker_symbol: "LKR", min_amount: "16762.00", max_amount: "6704613.00" },
    { ticker_symbol: "PAB", min_amount: "51.00", max_amount: "20285.00" },
    { ticker_symbol: "PGK", min_amount: "185.00", max_amount: "73714.00" },
    { ticker_symbol: "PYG", min_amount: "369074", max_amount: "147629369" },
    { ticker_symbol: "KES", min_amount: "7118.00", max_amount: "2846996.00" },
    { ticker_symbol: "RSD", min_amount: "5335.00", max_amount: "2133700.00" },
    { ticker_symbol: "SOS", min_amount: "28425.00", max_amount: "11369976.00" },
    { ticker_symbol: "MOP", min_amount: "408.00", max_amount: "163004.00" },
    { ticker_symbol: "MUR", min_amount: "2291.00", max_amount: "916100.00" },
    { ticker_symbol: "ISK", min_amount: "6624", max_amount: "2649396" },
    { ticker_symbol: "JMD", min_amount: "7831.00", max_amount: "3132365.00" },
    { ticker_symbol: "MKD", min_amount: "2806.00", max_amount: "1122373.00" },
    { ticker_symbol: "BHD", min_amount: "19.00", max_amount: "7538.00" },
    { ticker_symbol: "IQD", min_amount: "66438.00", max_amount: "26574865.00" },
    { ticker_symbol: "OMR", min_amount: "20.00", max_amount: "7699.00" },
];
exports.default = supportedFiat;
//# sourceMappingURL=fiats.js.map